import React, { useEffect } from "react";
import { Icon } from "@iconify/react";
import avatar from "../../assets/images/avatar.png";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import authSvc from "../../services/auth-service";
import { filter, skip } from "rxjs";
import { logout } from "../../redux/authSlice";
import { Dropdown } from "react-bootstrap";
import { pascalCase } from "pascal-case";
import { resetState } from "../../redux/surveySlice";

const HeaderSetting = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  const dispatch = useDispatch();
  useEffect(() => {
    const subscription = authSvc.loginObservable$
      .pipe(
        skip(1),
        filter((isLoggedIn) => !isLoggedIn)
      )
      .subscribe(() => logoutUser());

    return () => {
      subscription.unsubscribe();
    };
  }, []);

  const logoutUser = () => {
    localStorage.clear();
    dispatch(resetState());
    dispatch(logout());
  };
  return (
    <>
      <ul className="topRightLinks d-none d-md-flex">
        {/* <li>
          <Link to="#" className="notify">
            <Icon icon="lucide:bell" /> <span></span>
          </Link>
        </li> */}
        <li className="dropdownUser">
          <Dropdown>
            <Dropdown.Toggle variant="avatar" id="dropdown-basic">
              {/* <img src={avatar} alt="" /> */}
              {user?.firstName.charAt(0).toUpperCase() +
                user?.lastName.charAt(0).toUpperCase()}
            </Dropdown.Toggle>
            <Dropdown.Menu show>
              <Dropdown.Item className="avatarMenu">
                <div className="avImg">
                  {user?.firstName.charAt(0).toUpperCase() +
                    user?.lastName.charAt(0).toUpperCase()}
                </div>

                <div className="fullName">
                  {user?.firstName.toUpperCase() +
                    " " +
                    user?.lastName.toUpperCase()}
                </div>
                <div className="userType">
                  {pascalCase(user?.role || "surveyor")}{" "}
                </div>
              </Dropdown.Item>
              <hr />
              <Dropdown.Item
                onClick={() => logoutUser()}
                href="#"
                className="logOut"
              >
                <i>
                  <Icon icon="tabler:logout" />
                </i>{" "}
                <span>Logout</span>{" "}
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </li>
      </ul>
    </>
  );
};

export default HeaderSetting;
